import React from 'react';
import { Link, Redirect } from "react-router-dom";
import {
	Card,
	Form,
	Input,
	Button,
	message,
	Alert,
	Typography,
	Divider,
	DatePicker,
} from 'antd';
import {
	DiffOutlined,
	SaveOutlined,
	CloseCircleOutlined,
	CalendarOutlined,
	FileTextOutlined,
	ArrowLeftOutlined,
	EditOutlined,
	PlusCircleOutlined,
} from '@ant-design/icons';
import moment from 'moment';

import Config from '../../Config';

import { connect } from 'react-redux';
import {
	initHandler,
	ajaxViewHandler,
	ajaxHandler,
	setConfig,
	extractResult,
} from "../../store/actions";
import { Helmet } from "react-helmet";
import ErrorAlertModal from '../../components/ErrorAlertModal';

const { Text } = Typography;

const configClass = {
	apiUrl: {
		preview: "master/api/hari/libur/",
	},
	pageUrl: {
		data: '/admin/pengaturan/hari-libur/'
	},
};

const config = new Config();

const FIELD_STYLE = {
	borderRadius: 8,
	height: 40,
};

class FormHariLibur extends React.Component {
	formRef = React.createRef();

	constructor(props) {
		super(props);
		this.state = {
			isRedirect: false,
			errComponent: false,
			errTitle: '',
			errMsg: '',
			loadingButton: false,

			aksi: 'tambah',
			method: 'post',
			idLama: '',

			isMobile: window.innerWidth <= 768,
		};
	}

	UNSAFE_componentWillMount() {
		this.props.initHandler();
	}

	componentDidMount() {
		if (this.props.match.params.id !== undefined) {
			this.preview(this.props.match.params.id);
		}
		this._handleResize = () => this.setState({ isMobile: window.innerWidth <= 768 });
		window.addEventListener('resize', this._handleResize);
	}

	componentWillUnmount() {
		window.removeEventListener('resize', this._handleResize);
	}

	async preview(id) {
		message.loading({ content: 'Memuat data...', duration: 0, key: 'toast' });
		this.props.ajaxViewHandler('get', configClass.apiUrl.preview + id)
			.then((action) => {
				const { isSuccess, responseMsg: data } = extractResult(action);
				if (isSuccess) {
					this.formRef.current.setFieldsValue({
						nama: data.nama,
						tanggal: data.tanggal ? moment(data.tanggal, 'YYYY-MM-DD') : null,
					});
					message.destroy();
					this.setState({ aksi: 'edit', method: 'put', idLama: id + '/' });
				} else {
					const errTitle = 'Gagal memuat data';
					this.setState({ errTitle, errMsg: data });
					message.error({ content: errTitle, duration: 2, key: 'toast' });
				}
			})
			.catch(() => {
				message.error({ content: 'Gagal request data, coba lagi', duration: 2, key: 'toast' });
			});
	}

	handleSubmit = (values) => {
		this.postData({
			nama: values.nama,
			tanggal: values.tanggal ? values.tanggal.format('DD-MM-YYYY') : null,
		});
	}

	async postData(datas) {
		message.loading({ content: 'Menyimpan...', key: 'toast' });
		this.setState({ loadingButton: true });
		this.props.ajaxHandler(this.state.method, configClass.apiUrl.preview + this.state.idLama, datas, false, true)
			.then((action) => {
				this.setState({ loadingButton: false });
				const { isSuccess, responseMsg } = extractResult(action);
				if (isSuccess) {
					message.success({ content: 'Data berhasil disimpan', duration: 2, key: 'toast' });
					this.setState({ isRedirect: true });
				} else {
					const errTitle = 'Gagal menyimpan data';
					message.error({ content: errTitle, duration: 2, key: 'toast' });
					this.setState({ errTitle, errMsg: responseMsg });
				}
			})
			.catch(() => {
				this.setState({ loadingButton: false });
				message.error({ content: 'Kesalahan pengiriman data, coba lagi', duration: 2, key: 'toast' });
			});
	}

	render() {
		if (this.state.isRedirect) {
			return <Redirect to={configClass.pageUrl.data} />;
		}

		const { isMobile, aksi, errMsg, errTitle, loadingButton, errComponent } = this.state;
		const isEdit = aksi === 'edit';
		const pageTitle = isEdit ? 'Edit Hari Libur' : 'Tambah Hari Libur';

		return (
			<div>
				<Helmet>
					<title>{pageTitle + ' | ' + config.get_site_info().name}</title>
					<style>{`
						.form-hl-wrap .ant-form-item-label > label {
							font-weight: 600;
							color: #374151;
							font-size: 13px;
						}
						.form-hl-wrap .ant-input,
						.form-hl-wrap .ant-picker {
							border-radius: 8px !important;
						}
						.form-hl-wrap .ant-input:focus,
						.form-hl-wrap .ant-picker-focused {
							border-color: #1e4d8a !important;
							box-shadow: 0 0 0 2px rgba(30,77,138,0.1) !important;
						}
					`}</style>
				</Helmet>


				<ErrorAlertModal
					visible={errMsg !== ''}
					title={errTitle}
					error={errMsg}
					onClose={() => this.setState({ errTitle: '', errMsg: '' })}
				/>

				<Form
					layout="vertical"
					name="fdata"
					onFinish={this.handleSubmit}
					ref={this.formRef}
					className="form-hl-wrap"
				>
					<Card
						style={{
							borderRadius: 14,
							boxShadow: '0 4px 20px rgba(0,0,0,0.07)',
							overflow: 'hidden',
							maxWidth: 640,
						}}
						bodyStyle={{ padding: 0 }}
					>
						{/* Header */}
						<div style={{
							background: 'linear-gradient(135deg, #0f2847, #1e4d8a)',
							padding: '20px 24px',
							display: 'flex',
							alignItems: 'center',
							gap: 16,
						}}>
							<div style={{
								width: 52,
								height: 52,
								borderRadius: 14,
								background: 'rgba(255,255,255,0.15)',
								display: 'flex',
								alignItems: 'center',
								justifyContent: 'center',
								flexShrink: 0,
							}}>
								{isEdit
									? <EditOutlined style={{ color: '#fff', fontSize: 24 }} />
									: <PlusCircleOutlined style={{ color: '#fff', fontSize: 24 }} />
								}
							</div>
							<div style={{ flex: 1, minWidth: 0 }}>
								<div style={{ color: '#fff', fontWeight: 700, fontSize: 18, lineHeight: 1.3 }}>
									{pageTitle}
								</div>
								<div style={{ color: 'rgba(255,255,255,0.65)', fontSize: 13, marginTop: 3 }}>
									{isEdit
										? 'Ubah informasi hari libur'
										: 'Isi formulir untuk menambah hari libur baru'
									}
								</div>
							</div>
							<Link to={configClass.pageUrl.data}>
								<Button
									icon={<ArrowLeftOutlined />}
									style={{
										background: 'rgba(255,255,255,0.15)',
										border: 'none',
										color: '#fff',
										borderRadius: 8,
										flexShrink: 0,
									}}
								>
									{!isMobile && 'Kembali'}
								</Button>
							</Link>
						</div>

						{/* Section header */}
						<div style={{
							padding: '14px 24px',
							background: 'linear-gradient(135deg, #0f284711, #1e4d8a11)',
							borderBottom: '1.5px solid #d0dff5',
							display: 'flex',
							alignItems: 'center',
							gap: 10,
						}}>
							<CalendarOutlined style={{ color: '#1e4d8a', fontSize: 16 }} />
							<Text strong style={{ fontSize: 14, color: '#0f2847' }}>
								Informasi Hari Libur
							</Text>
						</div>

						{/* Form fields */}
						<div style={{ padding: '24px 28px' }}>
							<Form.Item
								label={<span><CalendarOutlined style={{ color: '#1e4d8a', marginRight: 6 }} />Tanggal</span>}
								name="tanggal"
								rules={[{ required: true, message: 'Tanggal harus diisi' }]}
							>
								<DatePicker
									format="DD-MM-YYYY"
									placeholder="Pilih tanggal hari libur"
									style={{ width: '100%', borderRadius: 8 }}
									allowClear
								/>
							</Form.Item>

							<Form.Item
								label={<span><FileTextOutlined style={{ color: '#1e4d8a', marginRight: 6 }} />Nama Hari Libur</span>}
								name="nama"
								rules={[{ required: true, message: 'Nama hari libur harus diisi' }]}
								style={{ marginBottom: 0 }}
							>
								<Input
									placeholder="Contoh: Hari Kemerdekaan RI, Lebaran, dst..."
									style={FIELD_STYLE}
								/>
							</Form.Item>
						</div>

						{/* Footer tombol */}
						<Divider style={{ margin: 0 }} />
						<div style={{
							padding: '16px 28px',
							display: 'flex',
							gap: 10,
							justifyContent: isMobile ? 'stretch' : 'flex-end',
							flexDirection: isMobile ? 'column' : 'row',
							background: '#fafafa',
						}}>
							<Link to={configClass.pageUrl.data} style={isMobile ? { display: 'block' } : {}}>
								<Button
									icon={<CloseCircleOutlined />}
									size="large"
									disabled={loadingButton}
									style={{ borderRadius: 10, ...(isMobile ? { width: '100%' } : {}) }}
								>
									Batal
								</Button>
							</Link>
							<Button
								type="primary"
								htmlType="submit"
								icon={<SaveOutlined />}
								size="large"
								loading={loadingButton}
								disabled={errComponent}
								style={{
									borderRadius: 10,
									background: 'linear-gradient(135deg, #0f2847, #1e4d8a)',
									border: 'none',
									fontWeight: 600,
									...(isMobile ? { width: '100%' } : {}),
								}}
							>
								{isEdit ? 'Simpan Perubahan' : 'Tambah Hari Libur'}
							</Button>
						</div>
					</Card>
				</Form>
			</div>
		);
	}
}

const mapStateToProps = function (state) {
	return state.configReducers;
}

export default connect(
	mapStateToProps,
	{
		initHandler,
		setConfig,
		ajaxViewHandler,
		ajaxHandler,
	}
)(FormHariLibur);
